import { useEffect, useState } from "react";
/**
 * This Hook can be used for detecting when the user is changing tabs
 */
function useTabActive() {
  const [active, setActive] = useState<boolean>(true);

  useEffect(() => {
    const handler = () => {
      setActive(document.visibilityState === "visible");
    };
    // Bind
    document.addEventListener("visibilitychange", handler);
    return () => {
      // dispose
      document.removeEventListener("visibilitychange", handler);
    };
  }, []);

  return active;
}

export default useTabActive;
